module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch3_20210921005649_T.3ff9050b.jpg";